import React from "react";
import styled from "styled-components";

import { Breakpoints } from "../../theme/Breakpoints";
import { Spacing } from "../../theme/Spacing";
import { Flex } from "../Flex";

const Container = styled(Flex)<{ subtle?: boolean }>`
  width: 100%;
  flex-direction: column;
  align-items: center;
  gap: ${Spacing.m};
  background-color: ${({ theme, subtle }) =>
    subtle ? theme.sub : theme.white};
  padding: ${Spacing.m};
  flex-grow: 1;
  margin-bottom: ${Spacing.xxxl};

  @media (min-width: ${Breakpoints.DESKTOP}) {
    border-inline-start: ${({ theme }) => `1px solid ${theme.darkSub}`};
  }
`;

interface StepperStepProps {
  children: React.ReactNode;
}

export const StepperStep: React.FC<StepperStepProps> = ({ children }) => {
  return <Container id="stepper-step">{children}</Container>;
};
